import { ModuleModel } from '../../module.model.interface';

export enum ManifestType {
  Definition
}

export class ManifestTypeDetail {
  public id: string;
  public name: string;
  public accept: string;
  public postfix: string;
  public extension: string;

  constructor(options?: {
    id: string,
    name: string,
    accept: string,
    postfix: string,
    extension: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
      this.accept = options.accept;
      this.postfix = options.postfix;
      this.extension = options.extension;
    }
  }
}

export const ManifestTypeMap = {
  // tslint:disable-next-line:max-line-length
  Definition: new ManifestTypeDetail({ id: 'Definition', name: 'Munkafolyamat sablon definíció (def)', accept: '.def', postfix: 'definíció', extension: '.def' })
};

export const ManifestTypeList: ManifestTypeDetail[] = [
  ManifestTypeMap.Definition,
];

export class WorkflowTemplateManifestDescriptor implements ModuleModel {
  public discriminator = 'WorkflowTemplateManifestDescriptor';

  public id: string;
  public workflowTemplateId: string;
  public manifestType: string;
  public size: string;
  public body: string;

  public href: string;
  public modified: Date;
  public deleted: Date;

  constructor(options?: {
    id: string;
    workflowTemplateId: string;
    manifestType: string;
    size: string;
    body: string;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.workflowTemplateId = options.workflowTemplateId;
      this.manifestType = options.manifestType;
      this.size = options.size;
      this.body = options.body;
      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/workflow.template.manifest/model/workflow.template.manifest.ts